import classNames from "classnames";
import { IWebsiteBuilderSlideshow, websiteBuilderGenerateSlideshowDesignStyles } from "pages/secure/facility/websiteBuilder/editor/nodes/container/websiteBuilderSlideshow";
import React from "react";
import { useTranslation } from "react-i18next";

interface IWebsiteBuilderSlideshowViewProps {
  node: IWebsiteBuilderSlideshow;
}

export function WebsiteBuilderSlideshowView(props: IWebsiteBuilderSlideshowViewProps) {
  const { node } = props;

  const { t } = useTranslation();

  const settings = node.container.settings;
  const designStyles = websiteBuilderGenerateSlideshowDesignStyles(settings);

  function renderContent() {
    const images = settings.images;

    if (images.length === 0) {
      return (
        <div className="editor-slideshow-instruction">
          <h3>{t("Add an image")}</h3>
          <p>{t("Double-click to configure the slideshow")}</p>
        </div>
      );
    } else {
      const { src, alt } = images[0];

      return (
        <div className={designStyles.contentClassName}>
          {settings.showArrows && images.length > 1 && (
            <>
              <button
                type="button"
                className={designStyles.leftChevronClassName}
              />
              <button
                type="button"
                className={designStyles.rightChevronClassName}
              />
            </>
          )}
          {settings.showPagination && images.length > 1 && (
            <div className={designStyles.paginationClassName}>
              {images.map((_, index) => (
                <button
                  key={index}
                  type="button"
                  className={classNames(designStyles.dotClassName, {
                    [designStyles.dotActiveClassName]: index === 0,
                  })}
                />
              ))}
            </div>
          )}
          <div className={designStyles.slideTrackClassName}>
            <div className={designStyles.slideClassName}>
              <img
                className={designStyles.backgroundImageClassName}
                src={src}
                alt=""
                draggable="false"
                aria-hidden="true"
              />
              <img
                className={designStyles.imageClassName}
                src={src}
                alt={alt}
                draggable="false"
              />
            </div>
          </div>
        </div>
      );
    }
  }

  return (
    <div
      className={classNames(designStyles.className, "editor-slideshow")}
      style={designStyles.styleProperties}
    >
      {renderContent()}
    </div>
  );
}
